import React from "react";
import { CircularProgress, IconButton } from "@mui/material";
import Refresh from "../../assets/SVGs/Table/Refresh";

const RefreshGrid = ({ isFetching = false, refetch }) => {
  return (
    <>
      {!isFetching && (
        <IconButton aria-label="Refresh" size="small" onClick={refetch}>
          <Refresh />
        </IconButton>
      )}
      {isFetching && (
        <span className="ml-2">
          <CircularProgress
            sx={{
              width: "24px!important",
              height: "24px!important",
              color: `${"#0D2EED"}`,
            }}
          />
        </span>
      )}
    </>
  );
};

export default RefreshGrid;
